import React, { useMemo, useState, useRef } from 'react'
import Table from '../_components/Table'
import data from '../fixtures'
import { Wrapper, TextDetail, Panel, TextAreaIcon, SelectFieldIcon, FileFieldIcon } from '../_components'
import Axios from 'axios'
import moment from 'moment'
import avatar from '../_images/avatar.png'
import { Formik } from 'formik'
import { handleFileChange } from '../_utils'

export default function UpliftCertificateSuspension( ) {
    const [ loading, setLoading ] = React.useState( true )
    const [ record, setRecord ] = useState( null )
    const [ files, setFiles ] = useState( [] )
    const ref = useRef(null);
    const [ comments, setComments ] = useState( [] )
    const [ remarks, setRemarks ] = useState( [] )
    const [ reportFile, setReportFile ] = useState( {} )

    React.useEffect( () => {
        if( loading ) {
            fetchApplication()
            fetchApplicationFiles()
            fetchAllRemarks()
        }
    },[ loading ])

    const fetchApplication = async () => {
        try {
            const response =  await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication/${localStorage.getItem( "applicationId" )}` )

            if( response.data ) {
                setRecord( response.data.record )
                setLoading( false )
            }
        } catch (error) {
            setLoading( false )
        }
    }

    const fetchApplicationFiles = async () => {
        let applicationId = localStorage.getItem( "applicationId" )
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getApplicationFiles/${applicationId}` )
            if( response.data ){
                setFiles( response.data?.data )
            }
        } catch (error) {}
    }

    const fetchAllRemarks = async () => {
        try {
            const response = await Axios.post(process.env.REACT_APP_API_URL+`/api/auth/getITRemarks`, {
                id: localStorage.getItem( "applicationId" )
            } )

            if( response.data ) {
                let results = response.data.filter( item => {
                    return item.comments !== null
                })
                setRemarks(  results )
            }
        } catch (error) {
            
        }
    }

    const previewFile = async (e) => {
        let file_id = e.target.id
        
        try {
            const email = btoa(localStorage.getItem( "email" )); // Base64 encode
            const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const handleFile = ( evt, tag ) => {
        handleFileChange( evt, tag, (response, file ) => {
            setReportFile( {
                document: response,
                name: file.name,
                size: file.size,
                tag: tag,
                type: file.type
            })
        })
    }

    const handleSuspensionLifting  = async ( values ) => {

        let savedFile = { 
            file: reportFile.document, 
            title: reportFile.name, 
            size: reportFile.size, 
            type: reportFile.type, 
        }
      
        let evidenceFile = Object.assign( {}, savedFile )

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/liftsuspension`, {
                id: record.id,
                email_address: record?.created_by,
                action: values.action,
                comments: values.comments,
                evidence_file: evidenceFile,
                actioned_by: localStorage.getItem( "username" ),
                role: localStorage.getItem( "role" )
            } )
            if( response.data ) {
                await localStorage.setItem( "link", "uplift_suspensions" )
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    const handleSuspensionLiftingByQA3  = async ( values ) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/actionOnSuspensionLiftByQAThree`, {
                id: record.id,
                email_address: record?.created_by,
                action: values.action,
                comments: values.comments,
                actioned_by: localStorage.getItem( "username" ),
                role: localStorage.getItem( "role" )
            } )
            if( response.data ) {
                await localStorage.setItem( "link", "uplift_suspensions" )
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    const handleSuspensionLiftingByApprover = async ( values ) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/actionOnSuspensionLiftByApprover`, {
                id: record.id,
                email_address: record?.created_by,
                action: values.action,
                comments: values.comments,
                actioned_by: localStorage.getItem( "username" ),
                role: localStorage.getItem( "role" )
            } )
            if( response.data ) {
                await localStorage.setItem( "link", "uplift_suspensions" )
                alert( response.data.message )
                return window.location.reload()
            }
        } catch (error) {}
    }

    return (
        <Wrapper>
            {loading ? (
                <div className="flex items-center justify h-full w-full">
                    {`Loading...`}
                </div>
            )
            :(<div className="bg-gray-100 h-full overflow-y-scroll grid gap-3 px-10 py-3">
            
            <div className="h-full bg-white rounded-sm grid">
                <div className="border-b border-gray-300 flex flex-row">
                <div className="flex flex-row items-center px-2">
                    {/* <button className="text-sm underline text-red-500" onClick={() => alert("back")}>Back</button> */}
                    <h2 className="p-5 text-sm font-bold uppercase">
                    {`Uplift Suspension for`}
                    </h2> <div className="text-blue-600 font-extrabold pb-1">{record?.trading_name}</div>
                </div>
                <div />
                </div>

                <div className="border-b border-gray-300 p-4">
                    <div className="h-full border border-gray-200 flex flex-row items-center justify-between rounded-sm">
                        <div className="grid gap-2 px-2" style={{ gridTemplateRows: "1rem auto"}}>
                            <h5 className="text-start text-xs uppercase">
                                {`Applicant`}
                            </h5>
                            <div className="flex flex-row px-2">
                                <div className="rounded-full border border-gray-200 overflow-hidden flex items-center justify-center w-10 h-10">
                                    <img src={avatar} alt="Profile Image" className="rounded-full" />
                                </div>
                                <div className="flex flex-col items-start justify-center px-2">
                                    <p className="text-xs">
                                        {/* {capitalizeName( record?.first_name + " " +  record?.surname )} */}
                                    </p>
                                    <p className="text-xs">
                                        {/* {record?.telephone} */}
                                    </p>
                                    <p className="text-xs">
                                        {/* {record?.email_address} */}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <div className="flex flex-col">
                            <TextDetail label="Created Date" val={moment( record?.created_at ).format( "DD-MMM-YYYY" )} />
                            <TextDetail label="Client Email Address" val={record?.created_by} />
                            <TextDetail label="Category" val={record?.category} />
                            <TextDetail label="Status" val={record?.status || "ONGOING"} color="red" />
                        </div>
                        <div />
                    </div>
                </div>

                <div className="w-full">                
                    <Panel label="Application Particulars">
                        <div className="grid grid-cols-2 gap-2 items-center">
                                {record?.category === "Individual" && [
                                    { label: "Category", value: record?.category, name: "category" },
                                    { label: "Given Name/ First Name", value: record?.given_name, name: "given_name" },
                                    { label: "Surname", value: record?.surname, name: "surname" },
                                    { label: "Other Name", value: record?.middle_name, name: "other_name" },
                                    { label: "Nationality", value: record?.nationality, name: "nationality" },
                                    { label: record?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: record?.nationality === "Ugandan" ? record?.national_id : record?.passport_number, name: "national_id" },
                                    { label: "Taxpayer Identification Number", value: record?.tin, name: "tin" }
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value}/>
                                    )
                                } )}

                                {record?.category === "Company" && [
                                    { label: "Certification Level", value: record?.certification_level, name: "certification_level" },
                                    { label: "Contact First Name", value: record?.contact_first_name, name: "contact_first_name" },
                                    { label: "Contact Last Name", value: record?.contact_last_name, name: "contact_last_name" },
                                    { label: "Other Name", value: record?.contact_middle_name, name: "contact_middle_name" },
                                    { label: "TIN", value: record?.tin, name: "tin" },
                                ].map( val => {
                                    return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                    )
                                } )}
                            </div>

                            <div className="grid grid-cols-2 gap-2 items-center">
                            {[
                                { label: "Date of Incorporation", value: record?.doc, name: "doc" },
                                { label: "Name of Entity", value: record?.entity_name, name: "entity_name" },
                                { label: "Entity Registration", value: record?.entity_registration, name: "entity_registration" },
                                { label: "Entity Type", value: record?.entity_type, name: "entity_type" },
                                { label: "BRN", value: record?.ern, name: "ern" },
                                { label: "Membership", value: record?.membership, name: "membership" },
                                { label: "Service Type", value: record?.service_type, name: "service_type" },
                                { label: "Business Trading Name", value: record?.trading_name, name: "trading_name" },
                                { label: "Website", value: record?.website, name: "website" },
                                { label: "Certificate No.", value: moment( record?.created_at ).format( "YYYY" ) + `-`+record?.id, name: "certificate_number" },
                            ].map( val => {
                                return (
                                    <TextDetail label={val.label} val={val.value} key={val.value} />
                                )
                            } )}
                        </div> 
                    </Panel>

                    <Panel label="Comments">
                        <table className="w-full border">
                            <thead className="text-xs bg-gray-200 font-bold p-2">
                                <th className="p-2">#</th>
                                <th>Actor</th>
                                <th>Comments</th>
                                <th>Action</th>
                                <th>Date Created</th>
                            </thead>
                            <tbody>
                                {remarks?.map( ( item, index ) => {
                                    return (
                                        <tr className="text-xs p-2 text-center">
                                            <td className="p-2">{`${index+1}`}</td>
                                            <td>{item.actioned_by}</td>
                                            <td>{item.comments}</td>
                                            <td>{item.action}</td>
                                            <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                                        </tr>
                                    )
                                } )}
                            </tbody>
                        </table>
                    </Panel>

                    <Panel label="Attachments">
                        <table className="w-full border">
                        <thead className="text-xs bg-gray-200 font-bold p-2">
                            <th className="p-2">#</th>
                            <th>Name</th>
                            <th>Size</th>
                            <th>Action</th>
                            <th>Date Created</th>
                        </thead>
                        <tbody>
                            {files?.map( ( item, index ) => {
                                return (
                                    <tr key={index} className="text-xs p-2 text-center">
                                        <td className="p-2">{`${index+1}`}</td>
                                        <td>{item.name}</td>
                                        <td>{item.size}</td>
                                        <td>
                                            <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a>

                                            <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" ref={ref} id={item.id} onClick={previewFile}>View File</a>
                                        </td>
                                        <td>{moment( item.created_at ).format("DD MMM, YYYY")}</td>
                                    </tr>
                                )
                            } )}
                        </tbody>
                        </table>
                    </Panel>

                    {localStorage.getItem( "role" )?.toUpperCase().includes("QA1") &&
                        <Panel label="Uplift Certificate Suspension">
                            <div className="flex flex-col items-start justify-center px-5 py-2">
                                <Formik initialValues={{
                                    action: comments[ 0 ]?.action || "",
                                    actioned_by: localStorage.getItem( "username" ),
                                    comments: comments[ 0 ]?.comments || ""
                                    }} onSubmit={handleSuspensionLifting}>
                                    { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                        return (
                                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                                <div className="w-full grid grid-rows-2 gap-1">
                                                    <SelectFieldIcon 
                                                        name="action"
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.action}
                                                        label="Action"
                                                        required={true}
                                                        disabled={comments[ 0 ]?.action ? true : false}
                                                        options={[ 
                                                            { id: 1, value: "UPLIFTED", label: "Uplift Suspension" }
                                                        ]}
                                                        question="Next Course of Action" 
                                                    />

                                                    <FileFieldIcon
                                                        noPadding
                                                        name="attachment"
                                                        value={values?.attachment}
                                                        handleChange={evt => {
                                                            handleChange(evt)
                                                            handleFile( evt, "evidence_report" )
                                                        }}
                                                        label="Evidence Report"
                                                        question="Add Evidence Report" 
                                                        required={false} 
                                                    />

                                                    <TextAreaIcon
                                                        rows={3}
                                                        cols={5}
                                                        name="comments"
                                                        value={values.comments}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        label="Comments"
                                                        disabled={comments[ 0 ]?.action ? true : false}
                                                        question={`Reason for lifiting suspension`}
                                                        required={true}
                                                    />
                                                </div>

                                                {! ( comments[ 0 ]?.action ) && 
                                                ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                    {`Submit`}
                                                </button> ) }
                                            </form>
                                        )
                                    }  }
                                </Formik>
                            </div>
                        </Panel>
                    }

                    {localStorage.getItem( "role" )?.toUpperCase().includes("QA3") &&
                        <Panel label="Action An Uplifted Certificate Suspension">
                        <div className="flex flex-col items-start justify-center px-5 py-2">
                            <Formik initialValues={{
                                action: comments[ 0 ]?.action || "",
                                actioned_by: localStorage.getItem( "username" ),
                                comments: comments[ 0 ]?.comments || ""
                                }} onSubmit={handleSuspensionLiftingByQA3}>
                                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                    return (
                                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                            <div className="w-full grid grid-rows-2 gap-1">
                                                <SelectFieldIcon 
                                                    name="action"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.action}
                                                    label="Action"
                                                    required={true}
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    options={[ 
                                                        { id: 1, value: "Approval", label: "Recommend for Approval" },
                                                        { id: 2, value: "Defer", label: "Defer" },
                                                        { id: 3, value: "Reject", label: "Recommend for Rejection" }
                                                    ]}
                                                    question="Next Course of Action" 
                                                />

                                                <TextAreaIcon
                                                    rows={3}
                                                    cols={5}
                                                    name="comments"
                                                    value={values.comments}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    label="Comments"
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    question={`Reason for lifiting suspension`}
                                                    required={true}
                                                />
                                            </div>

                                            {! ( comments[ 0 ]?.action ) && 
                                            ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                {`Submit`}
                                            </button> ) }
                                        </form>
                                    )
                                }  }
                            </Formik>
                        </div>
                    </Panel>
                    }

                    {localStorage.getItem( "role" )?.toUpperCase().includes("APPROVER") &&
                        <Panel label="Action An Uplifted Certificate Suspension">
                        <div className="flex flex-col items-start justify-center px-5 py-2">
                            <Formik initialValues={{
                                action: comments[ 0 ]?.action || "",
                                actioned_by: localStorage.getItem( "username" ),
                                comments: comments[ 0 ]?.comments || ""
                                }} onSubmit={handleSuspensionLiftingByApprover}>
                                { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                    return (
                                        <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                            <div className="w-full grid grid-rows-2 gap-1">
                                                <SelectFieldIcon 
                                                    name="action"
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    value={values.action}
                                                    label="Action"
                                                    required={true}
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    options={[ 
                                                        { id: 1, value: "APPROVED", label: "Approve" },
                                                        { id: 2, value: "DEFER", label: "Defer" },
                                                        { id: 3, value: "REJECT", label: "Reject" }
                                                    ]}
                                                    question="Next Course of Action" 
                                                />

                                                <TextAreaIcon
                                                    rows={3}
                                                    cols={5}
                                                    name="comments"
                                                    value={values.comments}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    label="Comments"
                                                    disabled={comments[ 0 ]?.action ? true : false}
                                                    question={`Reason for lifiting suspension`}
                                                    required={true}
                                                />
                                            </div>

                                            {! ( comments[ 0 ]?.action ) && 
                                            ( <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                                {`Submit`}
                                            </button> ) }
                                        </form>
                                    )
                                }  }
                            </Formik>
                        </div>
                    </Panel>
                    }
                </div>
            </div>
            </div> ) }
        </Wrapper>
    )
}